
import './medias-area.scss'

import { faCheck, faImage, faTimes, faTrash, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import Component from "vue-class-component";

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Media } from '@skinsoft/ui/src/item-card/media';
import { Touchable } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { PRINCIPAL_IMAGE_CLICK_TOPIC, DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC } from '../../../../busTopics';


@Component({
    components: {
        sMedia: Media,
        sTouchable: Touchable
    },
    props: ['mediasIds', 'id', 'canUpload', 'inProgress'],
    template: require("./medias-area.html")
})
export class MediaArea extends ReactiveVue {

    // Allows to differentiate multiple instances of this component in the defect tree
    public id: string;
    public mediasIds: string[];
    public canUpload: boolean;
    public inProgress: boolean;
    public isSetDefaultImage: boolean;

    // Icons
    private addImageIcon = faImage;
    private deleteIcon = faTrash;
    private checkIcon = faCheck;
    private crossIcon = faTimes;
    private anglesUp = faAngleUp;

    private displayDeleteOverlayList: boolean[] = [];
    private displayDefaultImageOverlayList: boolean[] = [];

    private onDefaultImage(index){
        this.displayDefaultImageOverlayList[index] = !this.displayDefaultImageOverlayList[index]
        this.$forceUpdate()
    }

    public onDefaultImageClick(index) {
        this.$parent.$emit(PRINCIPAL_IMAGE_CLICK_TOPIC,  this.mediasIds[index])
        this.cancelDefaultImage(index)
    }

    public cancelDefaultImage(index) {
        this.displayDefaultImageOverlayList[index] = false
        this.$forceUpdate()
    }

    public onFileUploaded(event) {
        const name = "REP-"+Date.now()+"."+ event.target.files[0].name.split('.').pop()
        const myNewFile = new File([event.target.files[0]], name, {type: event.target.files[0].type});
        const reader = new FileReader()
        reader.readAsDataURL(myNewFile)
        reader.addEventListener("load", () => {
            this.$parent.$emit(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: myNewFile })
        }, false);
    }

    public onImageClick(imageId, index) {
        this.$parent.$emit(IMAGE_CLICK_TOPIC, { id: imageId, imageListIndex: index })
    }

    public onTrashClick(index) {
        this.displayDeleteOverlayList[index] = !this.displayDeleteOverlayList[index]
        this.$forceUpdate()
    }


    public onDeleteImageClick(index) {
        this.$parent.$emit(DELETE_IMAGE_CLICK_TOPIC, { imageListIndex: index })
        this.mediasIds.splice(index, 1)
        this.displayDeleteOverlayList.splice(index, 1)
    }

    public cancelDelete(index) {
        this.displayDeleteOverlayList[index] = false
        this.$forceUpdate()
    }

    @Watch('mediasIds')
    public onMediasIdsChange() {
        this.displayDeleteOverlayList.push(false);
        this.displayDefaultImageOverlayList.push(false);
    }

    public changeMediaId(media){
        this.$parent.$emit('id-changed-from-cache', media)
    }
}